import axios from "axios";


export default axios.create({
  // headers: { school: schoolId },
  // params:{school:'seu'}
});
